import {
  Alert,
  AlertTitle,
  Button,
  Dialog,
  DialogTitle,
  Paper,
} from "@mui/material";
import { Stack } from "@mui/system";

import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import DeleteReceiptTable from "./DeleteReceiptTable";
import { ReceiptsEndPointLogic } from "../../../../../logic/Finance/ProviderExpense/ReceiptsEndpointLogic";
import { useDispatch, useSelector } from "react-redux";
import {
  selectUserToken,
  setDisplayErrorSnackBar,
} from "../../../../../features/userSlice";
import store from "../../../../../store";
import { useState } from "react";
import { setSelectedRow } from "../../../../../features/financeReceiptSlice";

interface DeleteReceiptProps {
  open: boolean;
  handleClose: () => void;
  deleteRow: any;
}

const tableHeadings = {
  company: "Company",
  receipt_number: "Receipt Number",
  receipt_amount: "Receipt Amount",
  fme: "FME",
  debit: "Debit",
  covered: "% Covered",
  fme_status: "Receipt Status",
};

const DeleteReceiptModal = ({
  open,
  handleClose,
  deleteRow,
}: DeleteReceiptProps) => {
  const oauthTokenHeader = useSelector(selectUserToken) as any;
  const dispatch = useDispatch();
  const { selectedReceiptDateRange } = useSelector(
    (state: any) => state.receipts
  );
  const from_date = selectedReceiptDateRange[0]?.format("YYYY-MM-DD");
  const to_date = selectedReceiptDateRange[1]?.format("YYYY-MM-DD");
  const [loading, setLoading] = useState(false);

  const handleDeleteReceipt = async () => {
    try {
      setLoading(true);
      const rows = Array.isArray(deleteRow) ? deleteRow : [deleteRow];

      for (const row of rows) {
        if (row?.receipt_shared_uid) {
          await ReceiptsEndPointLogic.deleteReceipt(
            oauthTokenHeader,
            row.receipt_shared_uid
          );
        }
      }

      await ReceiptsEndPointLogic.getAllReceiptData(
        oauthTokenHeader,
        from_date,
        to_date
      );
    } catch (error) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Failed to delete receipt",
          severity: "error",
        })
      );
    } finally {
      setLoading(false);
      handleClose();
      dispatch(setSelectedRow([]));
    }
  };

  const handleCancel = () => {
    handleClose();
    dispatch(setSelectedRow([]));
  };

  return (
    <>
      <Dialog
        open={open}
        PaperProps={{ sx: { width: "1200px", maxWidth: "1400px" } }}
      >
        <Paper sx={{ padding: "16px 24px 20px 24px" }}>
          <DialogTitle sx={{ padding: "0px 0px 16px 0px" }}>
            Delete Receipt?
          </DialogTitle>

          <Alert
            severity="warning"
            icon={
              <ErrorOutlineIcon
                sx={{ color: "rgba(237, 108, 2, 1)" }}
                fontSize="inherit"
              />
            }
            sx={{
              border: "1px solid rgba(237, 108, 2, 0.5)",
              color: "rgba(237, 108, 2, 1)",
              alignItems: "center",
            }}
          >
            <AlertTitle>
              This action can’t be undone, and the receipt will be permanently
              removed from your records.
            </AlertTitle>
            This action will also break the linkage to ant existing FME
          </Alert>

          <DeleteReceiptTable
            tableHeadings={tableHeadings}
            deleteRow={deleteRow}
          />

          <Stack flexDirection={"row"} justifyContent={"end"} marginTop={2}>
            <Button color="secondary" variant="outlined" onClick={handleCancel}>
              Cancel
            </Button>
            <Button
              sx={{ ml: 2 }}
              color="secondary"
              variant="contained"
              data-tracker="596"
              disabled={loading}
              loading={loading}
              onClick={handleDeleteReceipt}
            >
              DELETE anyway
            </Button>
          </Stack>
        </Paper>
      </Dialog>
    </>
  );
};

export default DeleteReceiptModal;
